/**
 * 装置管理トップで取得する装置管理情報JSONのクラス
 */
/**
 * 詳細ページボタンリンク情報
 */
export class EquipProductDetailLinkItem {
  linkId = 0
  linkTitle = ''
  linkUrl = ''
  linkTarget = ''
}

/**
 * 詳細ページ情報
 */
export class DetailItem {
  public parentTaxonomyId = 0
  public parentTaxonomy = ''
  public equipProductDetailLinks: EquipProductDetailLinkItem[] = []
}

/**
 * 機種別ページボタンリンク情報
 */
export class ButtonLinkInfoItem {
  public linkId = 0
  public linkTitle = ''
  public linkUrl = ''
}

/**
 * 機種別ページ情報
 */
export class EquipProductCategory {
  public equipProductCategoryId = 0
  public productCategoryId = 0
  public representImage = ''
  public altText = ''
  public title = ''
  public url = ''
  public equipProductDetails: DetailItem[] = []
  public equipProductButtonLinks: ButtonLinkInfoItem[] = []
}

export default EquipProductCategory
